import type { PromptCard } from '@atlassian/rovo-conversation-actions/prompt-cards';

/**
 * Filters prompt cards by search query, use cases, roles, and connectors.
 */
export function filterPromptCards(
	cards: PromptCard[],
	searchQuery: string,
	selectedUseCases: string[],
	selectedRoles: string[],
	selectedConnectors: string[] = [],
): PromptCard[] {
	const normalizedQuery = searchQuery.trim().toLowerCase();
	return cards.filter((card) => {
		// Search filter
		if (normalizedQuery) {
			const matchesSearch =
				card.title.toLowerCase().includes(normalizedQuery) ||
				card.prompt.toLowerCase().includes(normalizedQuery) ||
				(card.useCase?.toLowerCase().includes(normalizedQuery) ?? false) ||
				(card.roles?.some((role) => role.toLowerCase().includes(normalizedQuery)) ?? false) ||
				(card.appIds?.some((appId) => appId.toLowerCase().includes(normalizedQuery)) ?? false);
			if (!matchesSearch) {
				return false;
			}
		}
		// Use case filter
		if (selectedUseCases.length > 0) {
			if (!card.useCase || !selectedUseCases.includes(card.useCase)) {
				return false;
			}
		}
		// Role filter
		if (selectedRoles.length > 0) {
			if (!card.roles?.some((role) => selectedRoles.includes(role))) {
				return false;
			}
		}
		// Connector filter
		if (selectedConnectors.length > 0) {
			const hasMatchingConnector =
				card.appIds?.length && card.appIds.some((id) => selectedConnectors.includes(id));
			if (!hasMatchingConnector) {
				return false;
			}
		}
		return true;
	});
}
